import { api } from "@/lib/api";
import { type Schemas } from "@/types";
import { useQuery } from "react-query";

export default function ActiveCasesListQuery() {
  const { data } = useQuery({
    queryKey: ["activeCasesListStats"],
    queryFn: async () => {
      const response = await api.get<Schemas["ActiveCasesListStats"]>(
        "/api/Reports/ActiveCasesListStats",
      );
      return response.data;
    },
  });

  return {
    cases: data?.cases ?? [],
  };
}
